/**
 * @generated SignedSource<<607244e9fa0e28b4b44c3a080eda41d9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type userProfileNameInlineFragment$data = {
  readonly firstName: string;
  readonly lastName: string;
  readonly " $fragmentType": "userProfileNameInlineFragment";
};
export type userProfileNameInlineFragment$key = {
  readonly " $data"?: userProfileNameInlineFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"userProfileNameInlineFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "userProfileNameInlineFragment"
};

(node as any).hash = "f6e826846d6ee10398ffd5927fd32fe4";

export default node;
